import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';

import { Filter, CarOptionLocationDetails} from '../../routes/search-cars-component/car-filter.helper';

export interface StateObj {
    code: string;
    name: string;
};

@Component ({
    selector: 'app-location-filter',
    templateUrl: './location-filter.component.html',
    styleUrls: [ './location-filter.component.scss' ],
})

export class LocationFilterComponent implements OnChanges {
    @Input() options: CarOptionLocationDetails[] = [];
    @Input() filter: Filter = {
        field: '',
        title: '',
        open: false,
        values: [],
        displayAs: 'location',
    };
    @Input() value: any | undefined;

    @Output() selectionEmmiter: EventEmitter<any> = new EventEmitter();

    stateOptions: StateObj[] = [];
    selectedCountries: CarOptionLocationDetails[] = [];
    selectedStates: StateObj[] = [];

    form: FormGroup;
    country: FormControl;
    state: FormControl;
    fb: FormBuilder;

    constructor()
    {
        this.fb = new FormBuilder;
        this.country = new FormControl([]);
        this.state = new FormControl([]);
        this.form = new FormGroup({
            'country': this.country,
            'state': this.state,
        });
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['options']) {
            this.updateStateOptions();
        }
    }

    updateStateOptions() {
        let countryList = this.selectedCountries.length > 0?
            this.selectedCountries: this.options;
        
        this.stateOptions = countryList.reduce((res, option) => {
            if (option.states === null) return res;
            res.push(...option.states);
            return res;
        }, [] as StateObj[]).sort((a,b) => (a.name > b.name) ? 1 : -1);

        if (this.selectedStates.length === 0) return;
        this.selectedStates = this.selectedStates.filter(
            (state) => this.selectedCountries.some(
                (country) => country.states?.includes(state)
            )
        );
        this.selectState();
    }

    selectCountry(event: any) {
        let allIndex = this.options.findIndex((x) => x.states?.length === 0);
        if (allIndex != -1) {
            let all = this.options[allIndex];
            let selectedCountryNames = this.selectedCountries.map(x => x.name);
            if (event.itemValue.name === all.name) {
                this.selectedCountries = selectedCountryNames.includes(all.name)?
                this.options: [];
            } else {
                selectedCountryNames.push(all.name);
                this.selectedCountries = this.options.every(x => selectedCountryNames.includes(x.name))?
                this.options: this.selectedCountries.filter(x => x.name !== all.name);
            }
        }
        let filter: Filter = {
            ...this.filter,
            field: 'country',
        }
        this.selectionEmmiter.emit({ selected: this.selectedCountries, filter });
        this.updateStateOptions();
    }

    selectState() {
        let filter: Filter = {
            ...this.filter,
            field: 'state',
            carAttributeName: this.filter.carAttributeName2,
        }
        this.selectionEmmiter.emit({ selected: this.selectedStates, filter });
    }
}
